import { MapPin, Navigation, Clock, CalendarClock } from "lucide-react";

const countdown = (startIso) => {
  const diff = new Date(startIso).getTime() - Date.now();
  if (diff <= 0) return "Kicking off now";
  const hours = Math.round(diff / 3600000);
  if (hours < 1) return `In ${Math.max(1, Math.round(diff / 60000))} min`;
  if (hours < 24) return `In ${hours} hr`;
  const days = Math.round(hours / 24);
  return days === 1 ? "Tomorrow" : `In ${days} days`;
};

export const NextGameCard = ({ game, featured = false }) => {
  const start = new Date(game.start_iso);
  const mapsUrl = game.location
    ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(game.location)}`
    : null;

  return (
    <div
      className={`rounded-sm border p-4 ${featured ? "bg-[#0C2E3C] border-[#0C2E3C]" : "bg-white border-[#0C2E3C]/10"}`}
      data-testid={`next-game-${game.slug}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <CalendarClock size={13} className={featured ? "text-[#C8E64E]" : "text-[#0C2E3C]/40"} />
        <span className={`text-[10px] font-bold uppercase tracking-[0.15em] ${featured ? "text-[#C8E64E]" : "text-[#0C2E3C]/45"}`}>
          {countdown(game.start_iso)}
        </span>
      </div>

      <h3 className={`font-heading font-bold leading-tight ${featured ? "text-white text-xl" : "text-[#0C2E3C] text-base"}`}>
        {game.title}
      </h3>
      {!featured && game.team && (
        <p className="text-[11px] text-[#0C2E3C]/45 mt-0.5">{game.team}</p>
      )}

      <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 mt-2 text-xs ${featured ? "text-[#F0F4F3]/70" : "text-[#0C2E3C]/55"}`}>
        <span className="flex items-center gap-1.5">
          <Clock size={12} />
          {start.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
          {" · "}
          {start.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}
        </span>
        {game.location && (
          <span className="flex items-center gap-1.5">
            <MapPin size={12} /> {game.location}
          </span>
        )}
      </div>

      {mapsUrl && (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider transition-colors ${featured ? "bg-[#C8E64E] text-[#0C2E3C] hover:bg-[#C8E64E]/85" : "bg-[#0C2E3C] text-white hover:bg-[#0C2E3C]/90"}`}
          data-testid={`directions-${game.slug}`}
        >
          <Navigation size={11} /> Directions
        </a>
      )}
    </div>
  );
};
